import { graphqlClient } from "../../../client";
import mutationDocument from "./createOrderFromQuoteMutation.graphql";
import type {
  CreateOrderFromQuoteMutation,
  MutationsCreateOrderFromQuoteWithPaymentAuthorizationArgs,
} from "@/core/api/graphql/types";

export async function createOrderFromQuote(
  quoteId?: string,
): Promise<CreateOrderFromQuoteMutation["createOrderFromQuote"]> {
  const { data } = await graphqlClient.mutate<
    CreateOrderFromQuoteMutation,
    MutationsCreateOrderFromQuoteWithPaymentAuthorizationArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        id: quoteId,
      },
    },
  });

  return data?.createOrderFromQuote;
}
